var React = require('react');

function YellowX (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"#F7C800","key":0}),React.createElement("path",{"d":"M12.707 12L16 8.707L15.293 8L12 11.293L8.707 8L8 8.707L11.293 12L8 15.293L8.707 16L12 12.707L15.293 16L16 15.293L12.707 12Z","fill":"black","key":1})]);
}

YellowX.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = YellowX;

YellowX.default = YellowX;
